<template>
  <listview :vm="listVm" />
</template>

<script>
  import Listview from '@/components/base/Listview';
  import ListVm from '@/components/base/ListVm';
  import Router from '@/router';
  import Format from '@/format';

  const _comp = {
    name: 'LopendeOrders',
    data: () => ({
      listVm: null
    }),
    created() {
      this.listVm = new ListVm(
        'Lopende orders',
        'No',
        (ctx) => `/odata/SalesOrder?$filter=(Order_Date ge ${ctx.year}-01-01T00:00:00Z and Order_Date le ${ctx.year}-12-31T23:59:59Z) or Order_Date eq null`,
        ['Order_Date', 'Posting_Date', 'Shipment_Date'],
        (srch, items) => items.filter(i => `${i.No}${i.Your_Reference}${i.External_Document_No}`.toLowerCase().indexOf(srch.toLowerCase()) != -1),
        (item) => Router.push('/LopendeOrder/' + item.No),
        [
          { name: 'Nr.', sort: 'No', select: i => i.No },
          { name: 'Orderklantnr.', sort: 'Sell_to_Customer_No', select: i => i.Sell_to_Customer_No },
          { name: 'Naam', sort: 'Sell_to_Customer_Name', select: i => i.Sell_to_Customer_Name },
          { name: 'Orderdatum', sort: 'Order_Date', select: i => Format.date(i.Order_Date) },
/////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////
////////////////////
          { name: 'Extern documentnr', sort: 'External_Document_No', select: i => i.External_Document_No },
        ]
      );
    },
    components: {
      'listview': Listview
    }
  };

  export default _comp;
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/LopendeOrders.vue